import { render, staticRenderFns } from "./WelcomeInput.vue?vue&type=template&id=404bc435&"
import script from "./WelcomeInput.vue?vue&type=script&lang=js&"
export * from "./WelcomeInput.vue?vue&type=script&lang=js&"
import style0 from "./WelcomeInput.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports